import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button as ReactButton } from '@a-ui/react';
import Box from '../../../components/Box';
import { DetailLayout } from '../../../components/DetailLayout';
import { FormErrors } from '../../../components/Form';
import Form, { FormHelpers } from '../../../components/Form/Form';
import PasswordField from '../../../components/PasswordField';
import Typography from '../../../components/Typography';
import { api } from '../../../hooks/api.hooks';
import { translate } from '../../../i18n';
import { useMessage } from '../../../state/Message';
import { setMessage } from '../../../state/Message/actions';
import { initialValues, validationSchema } from './config';

interface PasswordUpdateProps {}

const PasswordUpdate: React.FC<PasswordUpdateProps> = () => {
  const { dispatch } = useMessage();
  const history = useHistory();

  const handleSubmit = async (values: any, { setErrors, setSubmitting }: FormHelpers) => {
    const { confirmPassword, ...body } = values;

    try {
      await api.put('/access-keys/password', body);
      dispatch(setMessage('accessKeys.password.update.success', 'accessKeysOverview', 'success'));
      window.location.replace('/auth/logout');
    } catch (e) {
      setErrors({
        oldPassword: 'error.server.wrong_credentials',
      });
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    history.push('/gegevens');
  };

  return (
    <DetailLayout
      title="accessKeys.password.update.title"
      description="accessKeys.password.update.intro"
      backAction="/gegevens"
      backLabel="accessKeys.overview.title"
    >
      <Box>
        <Form
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {({ isSubmitting }) => (
            <>
              <Typography variant="h2" as="h6" classNames="u-margin-bottom">
                {translate('accessKeys.password.update.subtitle')}
              </Typography>

              <Typography classNames="u-margin-bottom">
                {translate('accessKeys.password.update.description')}
              </Typography>

              <FormErrors />

              <PasswordField
                label={translate('accessKeys.password.update.current')}
                name="oldPassword"
                classNames="u-margin-bottom"
              />
              <div className="u-margin-top-s">
                <PasswordField
                  label={translate('accessKeys.password.update.new')}
                  name="newPassword"
                  showRequirements
                />
              </div>
              <div className="u-margin-top-s">
                <PasswordField
                  label={translate('input.label.password_confirm')}
                  name="confirmPassword"
                  classNames="u-margin-top u-margin-bottom"
                />
              </div>

              <div className="u-margin-top">
                <ReactButton htmlType="submit" fullWidth disabled={isSubmitting}>
                  {translate('common.button.next')}
                </ReactButton>
                <div className="u-margin-top-s">
                  <ReactButton emphasis="medium" fullWidth onClick={handleCancel}>
                    {translate('common.button.cancel')}
                  </ReactButton>
                </div>
              </div>
            </>
          )}
        </Form>
      </Box>
    </DetailLayout>
  );
};

export default PasswordUpdate;
